import {SEARCH_SELECT_ITEM, DO_SEARCH, SEARCH_ADD_SUGGESTIONS, SEARCH_FULL_RESULT, CLEAR_SUGGESTIONS, CLEAR_SELECT_ITEM, SEARCH_INPUT_CLICKED } from './actions';

var getSuggestion = function(suggestions, category, index) {

  if(typeof suggestions[category] === 'undefined') {

    return;
  }

  if(typeof suggestions[category][index] === 'undefined') {
    
    return;
  }

  suggestions[category][index].category = category;
  
  return suggestions[category][index];
};

const DefaultState = {
  term: '',
  suggestions: {},
  selectedItems: [],
  currentlySelected: {},//with group and element ID, for highlighting in search results container
  fullDisplay: false,
  inputClicked: false
};

const search = (state = DefaultState, action) => {
  switch (action.type) {
    case DO_SEARCH: {
      const {text} = action;
      /*
      //ja teksts nodzēsts, tad noņemt gaišo background no search input
      if (text == '') {
        state.inputClicked = false;
      }
      */
      
      state.term = action.text;
      
      return Object.assign({},
        {currentlySelected: {}}, state);

    }
      
    case CLEAR_SUGGESTIONS:

      return Object.assign({}, DefaultState);
    case SEARCH_INPUT_CLICKED:
  
        return Object.assign({}, state, {inputClicked: action.data});
    case SEARCH_ADD_SUGGESTIONS:

      const inputClicked = state.inputClicked;
      state.suggestions = action.suggestions;
      state.fullDisplay = false;
      
      if(state.term.length === 0){
        action.suggestions = {};
      }

      return Object.assign({}, DefaultState, {
        suggestions: action.suggestions,
        currentlySelected: {},
        inputClicked
      });
    case SEARCH_FULL_RESULT:

      state.fullDisplay = true;

      return Object.assign({}, state);
    case CLEAR_SELECT_ITEM:
    
      state.selectedItems = [];

      return Object.assign({}, state); 
    case SEARCH_SELECT_ITEM:

      state.selectedItems = [getSuggestion(state.suggestions, action.category, action.index)];

      return Object.assign({}, state, {zooming: action.zooming, currentlySelected: {item: action.index, category: action.category}});
    default:
      return state;
  }
};

export {search};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/search/reducer.js